import { c as _c } from "react/compiler-runtime";
import type { JsonSchemaObject } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import type { FieldType } from '../../../store/types';
import { schemaToFieldType } from '../../../store/wire';
const FIELD_TYPE_CONFIG: {
  value: FieldType;
  label: string;
  badge: string;
}[] = [{
  value: 'text',
  label: 'Text',
  badge: 'text'
}, {
  value: 'document',
  label: 'Document',
  badge: 'document'
}, {
  value: 'number',
  label: 'Number',
  badge: 'number'
}, {
  value: 'integer',
  label: 'Integer',
  badge: 'integer'
}, {
  value: 'boolean',
  label: 'Boolean',
  badge: 'boolean'
}, {
  value: 'enum',
  label: 'Enum',
  badge: 'enum'
}, {
  value: 'object',
  label: 'Object',
  badge: 'object'
}, {
  value: 'array<string>',
  label: 'List of text',
  badge: 'list of text'
}, {
  value: 'array<enum>',
  label: 'List of enums',
  badge: 'list of enums'
}, {
  value: 'array<object>',
  label: 'List of objects',
  badge: 'list of objects'
}];
export const FIELD_TYPE_BADGE = Object.fromEntries(FIELD_TYPE_CONFIG.map(t => [t.value, t.badge])) as Record<FieldType, string>;

// Read-only human label for a declared JSON schema (e.g. "integer", "list of text"), for consumers
// that display an agent input's type outside the builder.
export const schemaTypeLabel = (schema: JsonSchemaObject | undefined): string => FIELD_TYPE_BADGE[schemaToFieldType(schema)];
export const useFieldTypeOptions = t0 => {
  const $ = _c(8);
  const allowDocument = t0 === undefined ? false : t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.task"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  let t2;
  if ($[1] !== allowDocument || $[2] !== t) {
    let t3;
    if ($[4] !== allowDocument) {
      t3 = option => allowDocument || option.value !== "document";
      $[4] = allowDocument;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== t) {
      t4 = option_0 => {
        if (option_0.value === "object") {
          return {
            ...option_0,
            label: t(_temp)
          };
        }
        if (option_0.value === "array<string>") {
          return {
            ...option_0,
            label: t(_temp2)
          };
        }
        if (option_0.value === "array<enum>") {
          return {
            ...option_0,
            label: t(_temp3)
          };
        }
        if (option_0.value === "array<object>") {
          return {
            ...option_0,
            label: t(_temp4)
          };
        }
        return option_0;
      };
      $[6] = t;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    t2 = FIELD_TYPE_CONFIG.filter(t3).map(t4);
    $[1] = allowDocument;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
function _temp($) {
  return $.fieldTypes.object;
}
function _temp2($_0) {
  return $_0.fieldTypes.listOfText;
}
function _temp3($_1) {
  return $_1.fieldTypes.listOfEnums;
}
function _temp4($_2) {
  return $_2.fieldTypes.listOfObjects;
}